import axios from 'axios';

// Mac地址验证
function getMacVerify(){
    // mac加密串
    const encry_code = sessionStorage.getItem('encry_code') || '';
    let promise = new Promise((resolve,reject)=>{
        // 如果mac加密串为空则证明未开启MAC地址验证
        if(encry_code===""){
            resolve(encry_code)
        }
        // 有值代表开启MAC地址验证，与浏览器插件交互获取验证码
        else{
            let mac_address = '';
            //判断浏览器内核，根据浏览器内核，使用浏览器的方法调用插件
            const targetExtensionId = "benjmbndnehlnfafcpgemhaaongbibnh";
            try{
                // onDisconnect
                var port = window.chrome.runtime.connect(targetExtensionId, {name: "connect"});
                port.onDisconnect.addListener(function(message){
                    reject(
                        {
                            type:1,
                            code:'00001501',
                            info:'mac地址获取不成功,插件识别失败'
                        }
                    )
                    port.onDisconnect.removeListener();
                });
                var mac = '';
                // onMessage
                port.onMessage.addListener(function(e){
                    mac = e;
                    if(mac){
                        console.log('mac_address:'+JSON.stringify(mac));
                        mac_address=mac.res;
                        // 动态获取mac地址
                        resolve(mac_address);
                    }else{
                        reject('mac地址获取不成功,插件识别失败');
                        reject(
                            {
                                type:1,
                                code:'00001501',
                                info:'mac地址获取不成功,插件识别失败'
                            }
                        )
                    }
                });
                // 连接插件
                port.postMessage({key: encry_code});
            }catch(e){
                reject(
                    {
                        type:1,
                        code:'00001501',
                        info:'mac地址获取不成功,插件识别失败'
                    }
                )
            }
        }
    })
    return promise;
}
 
export default function ajax(url='',params={},type='GET'){
    
    // 资源验证code
    params.check_code = sessionStorage.getItem("check_code") || '';
    
    return new Promise((resolve,reject)=>{
        let promise ;
        // 获取mac地址
        getMacVerify().then((data)=>{
            // mac地址
            params.mac_addr = data;
            
            if('GET' === type.toUpperCase()){
                // 拼接字符串
                let paramsStr = '';
                Object.keys(params).forEach(key => {
                    if(params[key] !== ''){
                        paramsStr += key + '=' +params[key] + '&'
                    }
                })
                // 过滤最后参数的&
                if(paramsStr !== ''){
                    paramsStr = paramsStr.substr(0,paramsStr.lastIndexOf('&'))
                }
                // url完整路径
                url += '?'+paramsStr;
                promise = axios.get(url)
            }else if('POST' === type.toUpperCase()){
                promise = axios.post(url,params)
            }

            // 返回结果
            promise.then((response)=>{
                resolve(response.data)
            }).catch(()=>{
                reject(
                    {
                        type:2,
                        info:'ajax请求失败'
                    }
                )
            })
            
        }).catch((reason)=>{
            console.log(reason);
            reject(reason)
        })
        
        
    })
    
    
    
}